/* eslint-disable max-len */
import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/es/components/Icon';
import React, { SVGProps } from 'react';
import { IconProps } from './Icons';

export type { IconProps } from './Icons';

export { AnalyticsIcon } from './mobile/AnalyticsIcon';
export { AnalyzeIcon } from './mobile/AnalyzeIcon';
export { BackArrowIcon } from './mobile/BackArrowIcon';
export { BlueCheckIcon } from './mobile/BlueCheckIcon';
export { BurgerMenuIcon } from './mobile/BurgerMenuIcon';
export { CheckMobileIcon } from './mobile/CheckMobileIcon';
export { CoinMobileIcon } from './mobile/CoinMobileIcon';
export { CumulativeChartIcon } from './mobile/CumulativeChartIcon';
export { CustomizeDisclaimerIcon } from './mobile/CustomizeDisclaimerIcon';
export { DirectionIcon } from './mobile/DirectionIcon';
export { DragMobileIcon, DragMobileOldIcon } from './mobile/DragMobileIcon';
export { DrawerCloseIcon } from './mobile/DrawerCloseIcon';
export { EducationMobileIcon } from './mobile/EducationMobileIcon';
export { EditBlueIcon } from './mobile/EditBlueIcon';
export { EditMobileIcon } from './mobile/EditMobileIcon';
export { EmailIcon } from './mobile/EmailIcon';
export { EntityCardIcon } from './mobile/EntityCardIcon';
export { ExpandMobileIcon } from './mobile/ExpandMobileIcon';
export { FiltersMobileIcon } from './mobile/FiltersMobileIcon';
export { FullArrowBackIcon } from './mobile/FullArrowBackIcon';
export { GetReportIcon } from './mobile/GetReportIcon';
export { GisMobileIcon } from './mobile/GisMobileIcon';
export { HelpMobileIcon } from './mobile/HelpMobileIcon';
export { ImagePlaceholderIcon } from './mobile/ImagePlaceholderIcon';
export { InfoFilledMobileIcon } from './mobile/InfoFilledMobileIcon';
export { InfoMobileIcon } from './mobile/InfoMobileIcon';
export { LegendIcon } from './mobile/LegendIcon';
export { ListUpIcon } from './mobile/ListUpIcon';
export { LocationMobileIcon } from './mobile/LocationMobileIcon';
export { MapMobileIcon } from './mobile/MapMobileIcon';
export { MapViewMobileIcon } from './mobile/MapViewMobileIcon';
export { MicIcon } from './mobile/MicIcon';
export { MobileChevronIcon } from 'components/assets/Icons/mobile/MobileChevronIcon';
export { NoInternetIcon } from './mobile/NoInternetIcon';
export { PinMobileIcon } from './mobile/PinMobileIcon';
export { QuestionMarkIcon } from './mobile/QuestionMarkIcon';
export { ReplaceIcon } from './mobile/ReplaceIcon';
export { SearchMobileIcon } from './mobile/SearchMobileIcon';
export { SettingsMobileIcon } from './mobile/SettingsMobileIcon';
export { ShareMobileIcon } from './mobile/ShareMobileIcon';
export { SwitchOffIcon } from './mobile/SwitchOffIcon';
export { SwitchOnIcon } from './mobile/SwitchOnIcon';
export { TrashIcon } from './mobile/TrashIcon';
export { UserLocationIcon } from './mobile/UserLocationIcon';
export { VenueMobileIcon } from './mobile/VenueMobileIcon';

const MinusIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="18" viewBox="0 0 18 18">
        <g fill="currentColor" fillRule="evenodd">
            <path d="M18 9a1 1 0 00-1-1H1a1 1 0 000 2h16a1 1 0 001-1z" />
        </g>
    </svg>
);

const MobileFilterIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="18" height="19" viewBox="0 0 18 19">
        <g fill="none" fillRule="evenodd">
            <path
                stroke="#49565D"
                strokeWidth=".75"
                d="M7.092 15.723L18 15.723M0 15.723L3.289 15.723"
            />
            <path
                fill="currentColor"
                d="M3.29 15.723c0-1.05.85-1.902 1.9-1.902 1.05 0 1.902.852 1.902 1.902 0 1.05-.852 1.902-1.902 1.902-1.05 0-1.9-.852-1.9-1.902"
            />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M3.29 15.723c0-1.05.85-1.902 1.9-1.902 1.05 0 1.902.852 1.902 1.902 0 1.05-.852 1.902-1.902 1.902-1.05 0-1.9-.852-1.9-1.902z"
            />
            <path
                stroke="#49565D"
                strokeWidth=".75"
                d="M8.942 2.277L18 2.277M0 2.277L5.139 2.277"
            />
            <path
                fill="currentColor"
                d="M5.139 2.277c0-1.05.852-1.901 1.9-1.901 1.052 0 1.904.85 1.904 1.9 0 1.05-.852 1.903-1.903 1.903-1.05 0-1.901-.852-1.901-1.902"
            />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M5.139 2.277c0-1.05.852-1.901 1.9-1.901 1.052 0 1.904.85 1.904 1.9 0 1.05-.852 1.903-1.903 1.903-1.05 0-1.901-.852-1.901-1.902z"
            />
            <path stroke="#49565D" strokeWidth=".75" d="M13.56 9L18 9M0 9L9.757 9" />
            <path
                fill="currentColor"
                d="M9.757 9c0-1.05.852-1.902 1.902-1.902 1.05 0 1.902.851 1.902 1.902 0 1.05-.852 1.901-1.902 1.901-1.05 0-1.902-.85-1.902-1.9"
            />
            <path
                stroke="#49565D"
                strokeLinecap="round"
                strokeWidth=".75"
                d="M9.757 9c0-1.05.852-1.902 1.902-1.902 1.05 0 1.902.851 1.902 1.902 0 1.05-.852 1.901-1.902 1.901-1.05 0-1.902-.85-1.902-1.9z"
            />
        </g>
    </svg>
);

const PlusIconMobileSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.499 9C4.499 8.72331 4.72331 8.499 5 8.499H13C13.2767 8.499 13.501 8.72331 13.501 9C13.501 9.27669 13.2767 9.501 13 9.501H5C4.72331 9.501 4.499 9.27669 4.499 9Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 4.499C9.27669 4.499 9.501 4.72331 9.501 5V13C9.501 13.2767 9.27669 13.501 9 13.501C8.72331 13.501 8.499 13.2767 8.499 13V5C8.499 4.72331 8.72331 4.499 9 4.499Z"
            fill="currentColor"
        />
    </svg>
);

const DotsMoreMobileIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10 2.5C10 3.32843 9.32843 4 8.5 4C7.67157 4 7 3.32843 7 2.5C7 1.67157 7.67157 1 8.5 1C9.32843 1 10 1.67157 10 2.5Z"
            fill="#49565D"
        />
        <path
            d="M10 9C10 9.82843 9.32843 10.5 8.5 10.5C7.67157 10.5 7 9.82843 7 9C7 8.17157 7.67157 7.5 8.5 7.5C9.32843 7.5 10 8.17157 10 9Z"
            fill="#49565D"
        />
        <path
            d="M8.5 17C9.32843 17 10 16.3284 10 15.5C10 14.6716 9.32843 14 8.5 14C7.67157 14 7 14.6716 7 15.5C7 16.3284 7.67157 17 8.5 17Z"
            fill="#49565D"
        />
    </svg>
);

const LeftArrowIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg
        width="18"
        height="15"
        viewBox="0 0 18 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M16.8735 7.1147C16.8735 7.25013 16.8197 7.38002 16.724 7.47579C16.6282 7.57156 16.4983 7.62536 16.3629 7.62536H2.61696L7.87243 12.8817C7.9226 12.9285 7.96284 12.9849 7.99075 13.0475C8.01866 13.1102 8.03367 13.1778 8.03488 13.2463C8.03609 13.3149 8.02348 13.383 7.9978 13.4466C7.97211 13.5102 7.93388 13.5679 7.88539 13.6164C7.8369 13.6649 7.77914 13.7032 7.71556 13.7288C7.65197 13.7545 7.58387 13.7671 7.5153 13.7659C7.44673 13.7647 7.37911 13.7497 7.31647 13.7218C7.25383 13.6939 7.19746 13.6536 7.15071 13.6035L1.02288 7.47556C0.927249 7.37981 0.873535 7.25002 0.873535 7.1147C0.873535 6.97937 0.927249 6.84958 1.02288 6.75383L7.15071 0.625916C7.24751 0.535713 7.37555 0.486606 7.50784 0.488941C7.64013 0.491275 7.76636 0.544868 7.85992 0.63843C7.95348 0.731991 8.00707 0.858216 8.00941 0.990512C8.01174 1.12281 7.96263 1.25084 7.87243 1.34765L2.61696 6.60404H16.3629C16.4983 6.60404 16.6282 6.65784 16.724 6.75361C16.8197 6.84937 16.8735 6.97926 16.8735 7.1147Z"
            fill="#333333"
            stroke="#333333"
            strokeWidth="0.5"
        />
    </svg>
);

const LockSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.66602 16.6663C1.66602 14.8254 3.1584 13.333 4.99935 13.333H24.9993C26.8403 13.333 28.3327 14.8254 28.3327 16.6663V26.6663C28.3327 28.5073 26.8403 29.9997 24.9993 29.9997H4.99935C3.1584 29.9997 1.66602 28.5073 1.66602 26.6663V16.6663Z"
            fill="#E1E2FF"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.66602 13.3333V8.33333C6.66602 3.73096 10.397 0 14.9993 0C19.6017 0 23.3327 3.73096 23.3327 8.33333V13.3333H24.9993C26.8403 13.3333 28.3327 14.8257 28.3327 16.6667V26.6667C28.3327 28.5076 26.8403 30 24.9993 30H4.99935C3.1584 30 1.66602 28.5076 1.66602 26.6667V16.6667C1.66602 14.8257 3.1584 13.3333 4.99935 13.3333H6.66602ZM22.0827 13.3167V8.33333C22.0827 4.42132 18.9114 1.25 14.9993 1.25C11.0873 1.25 7.91602 4.42131 7.91602 8.33333V13.3167H10.8327V8.33333C10.8327 6.03214 12.6982 4.16667 14.9993 4.16667C17.3005 4.16667 19.166 6.03215 19.166 8.33333V13.3167H22.0827ZM12.0827 8.33333V13.3167H17.916V8.33333C17.916 6.7225 16.6102 5.41667 14.9993 5.41667C13.3885 5.41667 12.0827 6.7225 12.0827 8.33333ZM27.0827 16.6667C27.0827 15.5161 26.1499 14.5833 24.9993 14.5833H4.99935C3.84876 14.5833 2.91602 15.5161 2.91602 16.6667V26.6667C2.91602 27.8173 3.84876 28.75 4.99935 28.75H24.9993C26.1499 28.75 27.0827 27.8173 27.0827 26.6667V25H20.6243C20.2792 25 19.9993 24.7202 19.9993 24.375C19.9993 24.0298 20.2792 23.75 20.6243 23.75H27.0827V21.6667H20.6243C20.2792 21.6667 19.9993 21.3868 19.9993 21.0417C19.9993 20.6965 20.2792 20.4167 20.6243 20.4167H27.0827V18.3333H20.6243C20.2792 18.3333 19.9993 18.0535 19.9993 17.7083C19.9993 17.3632 20.2792 17.0833 20.6243 17.0833H27.0827V16.6667Z"
            fill="#5E63E5"
        />
    </svg>
);

export const MinusIcon = (props: IconProps) => <Icon component={MinusIconSvg} {...props} />;

export const MobileLockIcon = (props: IconProps) => <Icon component={LockSvg} {...props} />;

export const MobileFilterIcon = (props: IconProps) => (
    <Icon component={MobileFilterIconSvg} {...props} />
);

export const PlusIconMobile = (props: IconProps) => (
    <Icon component={PlusIconMobileSvg} {...props} />
);

export const DotsMoreMobileIcon = (props: IconProps) => (
    <Icon component={DotsMoreMobileIconSvg} {...props} />
);

export const LeftArrowIcon = (props: IconProps) => <Icon component={LeftArrowIconSvg} {...props} />;

export const userLocationMarker = () => {
    var svg = `
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.85">
    <circle cx="11" cy="11" r="11" fill="#C0D7F7"/>
    <circle cx="11" cy="11" r="5" fill="#0A7FFF" stroke="white" stroke-width="1.5"/>
    </g>
    </svg>
    `;
    const encoded = window.btoa(svg);
    return `data:image/svg+xml;base64,${encoded}`;
};
